<template>
  <div>
    <div class="container">
      <img src="../assets/img/Web_WhyRun.png" style="max-width:80%;" />
      <div class="select-container">
        <!-- <pre>{{whyRunning}}</pre>
        <pre>{{member.why_running_with}}</pre> -->
        <div class="select">
          <div class="reason" :key="reason.key" v-for="reason in reasons" v-on:click="setWhyRunning(reason)" v-bind:class="{active: whyRunning === reason}">
            <img  :src="imagePath(reason)"/>
          </div>
        </div>
      </div>
      <button v-on:click="next()" v-bind:class="{disabled: !whyRunning}">
        <img src="../assets/img/Button_Lets_Crush_It_Together.png" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhyRunning',
  props: ['member'],
  data () {
    return {
      whyRunning: null,
      reasons: [
        {key: 'NB', description: 'Not Bored'},
        {key: 'RF', description: 'Run Faster'},
        {key: 'LW', description: 'Lose Weight'},
        {key: 'MF', description: 'My First 5K'}
      ],
      imagePath: (reason) => {
        return require('../assets/img/Web_WhyRun_' + reason.key + '.png')
      }
    }
  },
  methods: {
    setWhyRunning (reason) {
      this.whyRunning = reason
      this.loadingIndicator = true
    },
    next () {
      this.$emit('next', this.whyRunning)
    }
  },
  mounted () {
    for (let i in this.reasons) {
      if (this.reasons[i].key === this.member.why_running_with) {
        this.setWhyRunning(this.reasons[i])
        this.next()
      }
    }
    // this.setWhyRunning(this.member.why_running_with)
    // if (this.memberData) {
    //   console.log('!!')
    //   console.log(this.memberData.why_running_with)
    // }

    // if(memberData) console.log(memberData)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.screen {
  background: url('../assets/img/vignette.png'), url('../assets/img/Background_Why_Run.jpg');
  background-position: center center, 25% 0;
  background-size: cover, cover;
  background-repeat: repeat, no-repeat;
}

@media only screen and (min-width: 320px) and (max-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {

  .screen {
    background: url('../assets/img/vignette.png'), url('../assets/img/Background_Why_Run_s.jpg');
    background-position: center center, 25% 0;
    background-size: cover, cover;
    background-repeat: repeat, no-repeat;
  }

}

.select {
  background: transparent;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
}

.select-container {
  display:flex;
  justify-content: center;
  width: 80%;
  margin: 20px 0;
}

.reason {
  border: none;
  background-color: transparent;
  width: 48%;
  cursor: pointer;
  margin: 0 0 10px;
}

.reason img {
  background-color: transparent;
  transition: all 500ms ease-in-out;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  border: solid 2px #fff;
}

.reason.active img {
  background-color: #f06;
}
</style>



// WEBPACK FOOTER //
// src/components/WhyRunning.vue